import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router";
import ReactDOM from 'react-dom/client';
import './index.css';
import Invitacion from './pages/invitacion/Invitacion';
import Asistencia from "./pages/asistencia/Asist";
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
      {/* <Route path="" element={<App />} /> */}
      <Route path="/invitacion/:hash" element={<Invitacion />} />
      <Route path="/asistencia/:hash" element={<Asistencia />} />
      {/* <Route path="/FindCotizacion" element={<FindCotizacion />} />
      <Route path="/Desgloce" element={<Desgloce />} />
      <Route path="/Transferencia" element={<Transferencia />} />
      <Route path="/Transferencias" element={<Transferencias />} />
      <Route path="/PDF" element={<PDFViewLink />} />
      <Route path="/PDFView" element={<PDFView />} />
      <Route path="/FactView" element={<FactView />} />
      <Route path="/PayView" element={<PayView />} /> */}
      </Routes>
    </BrowserRouter>
    
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
